<!-- 绑定手机号 -->
<template>
    <van-overlay :show="showBindMobile" class="bindMobilePop" @click="showBindMobile = false">
        <div class="wrapper" @click.stop>
            <p class="title">绑定手机</p>
            <img class="close" @click="showBindMobile = false" :src="require('@/common/images/mindex/icon-close.png')" alt="">
            <p class="tips">成功绑定后可使用该手机登录PC端参加课程学习。</p>
            <div class="item">
                <div class="itemName">手机号</div>
                <van-field v-model="bindMobile.mobileno" maxlength="11" type="tel" placeholder="请输入您的手机号" />
            </div>
            <div class="item imgcode">
                <div class="itemName">图形码</div>
                <van-field v-model="bindMobile.usercode" placeholder="请输入图形验证码">
                    <template #button>
                        <van-button size="small" type="primary">
                            <img @click="creatImgCode" :src="imgCode" alt="">
                        </van-button>
                    </template>
                </van-field>
            </div>
            <div class="item code">
                <div class="itemName">验证码</div>
                <van-field v-model="bindMobile.smscode" placeholder="请输入验证码">
                    <template #button>
                        <van-button size="small" type="primary" @click="getSmsCode">{{second === 90 ? '发送验证码' : second+'s'}}</van-button>
                    </template>
                </van-field>
            </div>
            <div class="btn">
                <van-button @click="checkBindMobile">确定</van-button>
            </div>
        </div>
    </van-overlay>
</template>

<script>
import {checkBindMobile} from 'api/systemApi'
import {getSmsCode, creatImgCode} from 'api/api'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            showBindMobile: false,
            bindMobile: {
            mobileno: '',
            smscode: '',
            usercode: ''
            },
            imgCode: '',
            codeEncryption: '',
            second: 90
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        showCheckBindMobile() {
            this.showBindMobile = true
            if (!this.imgCode) {
                this.creatImgCode()
            }
        },
        getSmsCode() {
            if (!this.bindMobile.mobileno) {
            this.$toast.fail('请输入手机号')
            return
            } else if (!this.bindMobile.usercode) {
            this.$toast.fail('请输入图形验证码')
            return
            }
            if (this.second === 90) {
            this.setLoading(true)
            getSmsCode({
                data: { mobileno: this.bindMobile.mobileno,
                        usercode: this.bindMobile.usercode,
                        codeEncryption: this.codeEncryption
                },
                success: () => {
                    this.setLoading(false)
                    const that = this
                    const timer = setInterval(() => {
                        if (that.second > 1) {
                        --that.second
                        } else {
                        clearInterval(timer)
                        that.second = 90
                        }
                    }, 1000);
                    this.$toast.success('验证码发送成功')
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
            }
        },
        checkBindMobile() {
            if (!this.bindMobile.mobileno) {
                this.$toast.fail('请输入手机号')
                return
            } else if (!this.bindMobile.usercode) {
                this.$toast.fail('请输入图形验证码')
                return
            } else if (!this.bindMobile.smscode) {
                this.$toast.fail('请输入手机验证码')
                return
            }
            this.setLoading(true)
            checkBindMobile({
                data: this.bindMobile,
                success: res => {
                    this.setLoading(false)
                    const user = {
                        innerid: res.data.innerid,
                        loginname: res.data.loginname,
                        loginToken: res.data.logintoken,
                        logourl: res.data.logourl,
                        name: res.data.name,
                        mobile: res.data.mobile,
                        email: res.data.email,
                        nickname: res.data.nickname,
                        isperfect: 1,
                        isLogin: true,
                        zjmemtype: res.data.zjmemtype ? res.data.zjmemtype : 0
                    }
                    window.sessionStorage.setItem('user', JSON.stringify(user))
                    this.setUser(user)
                    this.$toast.success('绑定成功，请继续')
                    this.showBindMobile = false
                    // console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        creatImgCode() {
            this.setLoading(true)
            creatImgCode({
                data: {},
                success: res => {
                    this.setLoading(false)
                    this.bindMobile.usercode = ''
                    this.imgCode = res.result.base64
                    this.codeEncryption = res.result.codeEncryption
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setUser'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .bindMobilePop {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0.32rem;
        box-sizing: border-box;
        .wrapper {
            flex: 1;
            height: 7.74rem;
            background: #FFFFFF;
            border-radius: 0.25rem;
            position: relative;
            .title {
            text-align: center;
            font-weight: bold;
            font-size: 0.32rem;
            line-height: 0.45rem;
            padding: 0.22rem 0 0.28rem;
            }
            .close {
            width: 0.42rem;
            height: 0.42rem;
            position: absolute;
            top: 0.22rem;
            right: 0.28rem;
            }
            .tips {
            text-align: center;
            color: #EC5E69;
            font-size: 0.28rem;
            margin-bottom: 0.28rem;
            }
            .item {
            padding: 0 0.28rem;
            margin-bottom: 0.26rem;
            .itemName {
                font-size: 0.28rem;
                line-height: 0.4rem;
                // margin-bottom: 0.1rem;
            }
            .van-field {
                padding: 0.2rem 0;
                border-bottom: 0.01rem solid #E5E5E5;
                font-size: 0.28rem;
            }
            &.code {
                .van-button {
                    background: #fff;
                    color: #409EFF;
                    border: none;
                    font-size: 0.28rem;
                }
            }
            &.imgcode {
                .van-button {
                    background: #fff;
                    border: none;
                    img {
                    width: 1.6rem;
                    height: 0.6rem;
                    }
                }
            }
            }
            .btn {
            padding: 0 0.58rem;
            .van-button {
                width: 100%;
                height: 0.8rem;
                background: #409EFF;
                color: #fff;
                border-radius: 1rem;
                line-height: 0.8rem;
                padding: 0;
            }
            }
        }
    }
</style>